type CheckoutParams = {
  countryCode: string
  slug: string
  orderId: string
}

export const routes = {
  home: "/",
  downloadApp: "/download-app",
  restaurants: (countryCode?: string) => {
    if (!countryCode) {
      return routes.home
    }
    return `/${countryCode}/restaurants`
  },
  restaurant: (countryCode: string | undefined, identifier: string) => {
    if (!countryCode) {
      return `/restaurants/${identifier}`
    }
    return `/${countryCode}/restaurants/${identifier}`
  },
  checkout: {
    base: ({ countryCode, slug, orderId }: CheckoutParams) => {
      if (!countryCode) {
        return `/restaurants/${slug}/checkout/${orderId}`
      }
      return `/${countryCode}/restaurants/${slug}/checkout/${orderId}`
    },
    creditCards: {
      base: ({ countryCode, slug, orderId }: CheckoutParams) => {
        if (!countryCode) {
          return `/restaurants/${slug}/checkout/${orderId}/credit-cards`
        }
        return `/${countryCode}/restaurants/${slug}/checkout/${orderId}/credit-cards`
      },
      add: ({ countryCode, slug, orderId }: CheckoutParams) => {
        if (!countryCode) {
          return `/restaurants/${slug}/checkout/${orderId}/credit-cards/add`
        }
        return `/${countryCode}/restaurants/${slug}/checkout/${orderId}/credit-cards/add`
      },
    },
    redirect: ({ countryCode, slug, orderId }: CheckoutParams) => {
      if (!countryCode) {
        return `/restaurants/${slug}/checkout/${orderId}/redirect`
      }
      return `/${countryCode}/restaurants/${slug}/checkout/${orderId}/redirect`
    },
    payment: {
      base: ({
        countryCode,
        slug,
        orderId,
        search,
      }: CheckoutParams & {
        search: {
          type: "wallet" | "card" | "card_sca"
          phonenumberPrefix: string
          phoneNumber?: string
        }
      }) => {
        const searchParams = new URLSearchParams()
        Object.entries(search).forEach(([key, value]) => {
          searchParams.set(key, value)
        })
        if (!countryCode) {
          return `/restaurants/${slug}/checkout/${orderId}/payment?${searchParams.toString()}`
        }
        return `/${countryCode}/restaurants/${slug}/checkout/${orderId}/payment?${searchParams.toString()}`
      },
      status: ({
        countryCode,
        slug,
        orderId,
        search,
      }: CheckoutParams & {
        search:
          | {
              errorType: string
              errorMessage: string
              status: "failed"
            }
          | {
              status: "success"
            }
      }) => {
        const searchParams = new URLSearchParams()
        Object.entries(search).forEach(([key, value]) => {
          searchParams.set(key, value)
        })
        if (!countryCode) {
          return `/restaurants/${slug}/checkout/${orderId}/payment/status?${searchParams.toString()}`
        }
        return `/${countryCode}/restaurants/${slug}/checkout/${orderId}/payment/status?${searchParams.toString()}`
      },
    },
  },
  profile: (countryCode: string | undefined) => {
    if (!countryCode) {
      return `/profile`
    }
    return `/${countryCode}/profile`
  },
  profileBirthday: (countryCode: string | undefined) => {
    if (!countryCode) {
      return `/profile/birthday`
    }
    return `/${countryCode}/profile/birthday`
  },
  orderStatus: "/order-status",
  notFound: "/404",
  legal: {
    overview: "/legal",
    terms: "/legal/terms",
    privacy: "/legal/privacy",
    marketing: "/legal/marketing",
    cookies: "/legal/cookies",
  },
  cardForm: "/card-form",
}

export const routeParams = {
  countryCode: "country-code",
  orderId: "orderId",
  slug: "slug",
}
